import { matchPath } from 'react-router';

/**
 * The builder's routes as PATTERNS, which is all a page view records: `/project/:id`, never the id.
 * Kept beside routes.tsx by a test (routePatterns.test.ts) that fails when a route is added there
 * and not here — an unlisted route is still counted, as `other`.
 */
export const ROUTE_PATTERNS = [
  '/', '/discover', '/my-apps', '/account', '/credits', '/redeem', '/billing/success', '/billing/cancelled',
  '/sign-in', '/sign-up', '/confirm', '/auth/callback', '/forgot-password', '/new', '/new/idea', '/new/plan', '/new/building',
  '/project/:id', '/project/:id/preview', '/app/:appId', '/members/:appId', '/users/:appId',
  '/broadcast/:appId', '/invite/:token', '/creator/:id', '/submissions/:id', '/admin/metrics', 'other',
] as const;
export type RoutePattern = (typeof ROUTE_PATTERNS)[number];

/** The pattern a location matches, or `other`. Never the path itself. */
export function routePattern(pathname: string): RoutePattern {
  for (const pattern of ROUTE_PATTERNS) {
    if (pattern !== 'other' && matchPath({ path: pattern, end: true }, pathname)) return pattern;
  }
  return 'other';
}
